import { Alert, Button, Modal } from 'react-bootstrap'

type Props = {
  show: boolean
  itemName: string
  itemCost: number
  onConfirm: () => void
  onHide: () => void
  isLoading: boolean
}

const DeleteOrderItemModal = ({
  show,
  itemName,
  itemCost,
  onConfirm,
  onHide,
  isLoading,
}: Props) => (
  <Modal show={show} onHide={onHide}>
    <Modal.Header closeButton>
      <Modal.Title>Usuń element zamówienia</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Alert variant="warning">
        Element zostanie ukryty przed klientem, a kwota zamówienia zostanie
        przeliczona. Można go przywrócić w każdej chwili.
      </Alert>
      <p>
        Czy na pewno chcesz usunąć <strong>{itemName}</strong>?
      </p>
      <p>
        Koszt elementu: <strong>{itemCost.toFixed(2)} zł</strong>
      </p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide} disabled={isLoading}>
        Anuluj
      </Button>
      <Button variant="danger" onClick={onConfirm} disabled={isLoading}>
        {isLoading ? 'Usuwanie…' : 'Usuń'}
      </Button>
    </Modal.Footer>
  </Modal>
)

export default DeleteOrderItemModal
